define('views/modules/calendar/activity/detail/blocks/details-form',[
    // Libs
    'underscore', 'backbone', 'mustache', 'utils',
    // views
    'views/parts/info-section',
    'views/parts/form/textbox',
    'views/parts/form/textarea',
    'views/parts/form/select',
    // templates
    'text!templates/modules/calendar/activity/detail/blocks/details-form.html',
], function(
    // Libs
    _, Backbone, Mustache, U,
    // views
    VInfoSection,
    VTextbox,
    VTextarea,
    VSelect,
    // templates
    TActivityDetailsForm
) {

    var VActivityDetailsForm = Backbone.View.extend({
        template: TActivityDetailsForm,

        // abstracting selectors out of the view logic
        regions: {
            title: ".form-title",
            description: ".form-description",
            date: ".form-date",
        },

        initialize: function(opt) {
            this.options = opt || {};
            this.group = this.options.group;

            this.view = {
                info: new VInfoSection({
                    title: "calendar:What did you do today?",
                    //help: "messages:helpbox-activity-description",
                }),
                form: {
                    title: new VTextbox({ label: 'calendar:Display name for you client', attribute: 'sup_name', labelposition: 'outer', model: this.model }),
                    description: new VTextarea({
                        label: 'calendar:Details about your activity',
                        attribute: 'sup_description',
                        labelposition: 'outer',
                        autosize: true,
                        rows: 3,
                        markdownHelp: true,
                        model: this.model
                    }),
                }
            };
        },

        render: function() {
            var view = this.view,
                html = Mustache.render(this.template, Mustache.getContext());

            this.assign(view.info, this.$el); // must be first

            view.info.setContent(html);

            this.generateZones();
            var zone = this.zone;

            this.assign(view.form.title, zone.$title)
                .assign(view.form.description, zone.$description);

            return this;
        },

    });

    return VActivityDetailsForm;

});

